import React from 'react';

type Size = 'sm' | 'md' | 'lg' | 'xl';

interface LoaderProps {
  size?: Size;
  className?: string;
  label?: string;
}

const sizeClass: Record<Size, string> = {
  sm: 'ab-loader-sm',
  md: '',
  lg: 'ab-loader-lg',
  xl: 'ab-loader-xl',
};

// KAN-21358 — inline SVG (was background-image with embedded SMIL <animate>).
// SMIL `repeatCount='indefinite'` kept the Chromium renderer perpetually
// invalidating frames, which caused CDP `Page.captureScreenshot` to time out
// after 30s on the desktop /track route during the brief loader window. CSS
// keyframes on the inline SVG let the compositor settle between frames so
// automated screenshots succeed; rendered visual is identical.
const FootballLoaderSvg: React.FC = () => (
  <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g transform="rotate(-9 100 100)">
      <ellipse
        cx="100"
        cy="100"
        rx="78"
        ry="38"
        fill="none"
        stroke="#FB923C"
        strokeWidth="1.5"
        strokeDasharray="6 5"
      />
      <line
        x1="22"
        y1="100"
        x2="178"
        y2="100"
        stroke="#9A3412"
        strokeWidth="1"
        opacity="0.7"
      />
      <circle cx="22" cy="100" r="2.5" fill="#FB923C" />
      <circle cx="178" cy="100" r="2.5" fill="#FB923C" />
      <path
        className="ab-loader-path"
        d="M 36 110 L 56 96 L 76 112 L 96 88 L 116 100 L 136 80 L 156 92 L 168 76"
        fill="none"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        pathLength={220}
        strokeDasharray="220"
      />
      <circle className="ab-loader-apex" cx="168" cy="76" fill="white" />
    </g>
  </svg>
);

const Loader: React.FC<LoaderProps> = ({ size = 'md', className = '', label = 'Loading' }) => {
  return (
    <span
      className={`ab-loader ${sizeClass[size]} ${className}`.trim()}
      role="status"
      aria-label={label}
    >
      <FootballLoaderSvg />
    </span>
  );
};

export default Loader;
